import React, { createContext, PropsWithChildren, useContext, useEffect, useState } from "react"

import { CustomerInfo } from "./types/CustomerInfo"
import { CustomerInfoService } from "./types/CustomerInfoService"
import { setDeliveryV2Enabled } from "../DeliveryV2Enabled"
import { useCommonEventBus } from "../hooks/useCommonEventBus"

class CustomerInfoState {
  loading: boolean = false
  data: CustomerInfo | null = null
  error: null | unknown = null
}

const defaultState = new CustomerInfoState()

const Context = createContext(defaultState)
export const useCustomerInfo = () => useContext(Context)

export const CustomerInfoProvider = ({ children, service }: PropsWithChildren & { service: CustomerInfoService }) => {
  const bus = useCommonEventBus()
  const [state, setState] = useState(defaultState)

  useEffect(() => {
    const queryCustomerInfo = async () => {
      try {
        setState((prev) => ({ ...prev, loading: true, error: null }))
        const { data } = await service.getCustomerInfo()

        setDeliveryV2Enabled(data || undefined)

        setState({ loading: false, error: null, data })
      } catch (error) {
        setState((prev) => ({ ...prev, loading: false, error }))
      }
    }

    queryCustomerInfo()

    return bus.on("App > GlobalSettings > Fetch", queryCustomerInfo)
  }, [service])

  return <Context.Provider value={state}>{children}</Context.Provider>
}
